import styled from "styled-components";

export const ContainerInvisible = styled.div.attrs({})`
  @media (max-width: 570px) {
    display: none;
  }
`;

export const ContainerVisible = styled.div.attrs({})`
  display: none;
  @media (max-width: 570px) {
    display: block;
  }
`;

export const Content = styled.div.attrs({})`
  padding: 40px clamp(18px, 3vw, 40px);
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const HelpTitle = styled.div.attrs({})`
  font-family: Gilroy;
  font-size: clamp(30px, 4vw, 40px);
  font-weight: 700;
  line-height: 1.04;
  letter-spacing: -0.04em;
  color: ${p => p.theme.palette.colors.text};
`;

export const SupportTitle = styled.div.attrs({})`
  font-family: Poppins;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: ${p => p.theme.palette.colors.subdued};
`;

export const SupportText = styled.div.attrs({})`
  font-family: Lato;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  color: ${p => p.theme.palette.colors.muted};
`;

export const SupportHeader = styled.div.attrs({})`
  display: flex;
  gap: 24px;
  justify-content: space-between;
  align-items: flex-end;

  @media (max-width: 991px) {
    flex-direction: column;
    align-items: stretch;
  }
`;

export const HeaderContainer = styled.div.attrs({})`
  display: flex;
  flex-direction: column;
  gap: 16px;
  max-width: 760px;
`;
